import { css } from 'aphrodite';
import { Tabs as RadixTabs } from 'radix-ui';
import * as React from 'react';
import { styleSheet } from './styles';

type ThemeProps = {
	variant?: 'primary' | 'none';
};

export const TabRoot = RadixTabs.Root;

export const TabContent = RadixTabs.TabsContent;

export const BasicTabTrigger = RadixTabs.Trigger;

export const BasicTabList = RadixTabs.List;

export const TabList: React.FC<AphroditeStyled<React.ComponentProps<typeof RadixTabs.List>> & ThemeProps> = ({
	styles = [],
	variant = 'primary',
	...props
}) => {
	return <RadixTabs.List className={css(variant === 'primary' && styleSheet.primaryTabList, ...styles)} {...props} />;
};

export const TabTrigger: React.FC<AphroditeStyled<React.ComponentProps<typeof RadixTabs.Trigger>> & ThemeProps> = ({
	styles = [],
	variant = 'primary',
	...props
}) => {
	return (
		<RadixTabs.Trigger className={css(variant === 'primary' && styleSheet.primaryTabTrigger, ...styles)} {...props} />
	);
};

export const IconTabTrigger: React.FC<
	AphroditeStyled<React.ComponentProps<typeof RadixTabs.Trigger>> &
		ThemeProps & {
			icon: React.ReactNode;
		}
> = ({ icon: Icon, children, styles = [], variant = 'primary', ...props }) => {
	return (
		<RadixTabs.Trigger className={css(variant === 'primary' && styleSheet.primaryTabTrigger, ...styles)} {...props}>
			<figure className='tab-icon'>{Icon}</figure>
			{children}
		</RadixTabs.Trigger>
	);
};
